module.exports = __webpack_public_path__ + "static/media/manageActivity.6405365a.svg";